import {useQuery} from '@tanstack/react-query'

import {getAuthToken} from '@/lib/food-grubhub/foodGrubhubService'
import {useGrubhubTokenInfo} from '@/lib/food-grubhub/store'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

const useGrubhubGetAuth = () => {
  const [_token, setToken] = useGrubhubTokenInfo()

  return useQuery({
    queryKey: ['auth'],
    queryFn: async () => {
      const res = await getAuthToken({signal: undefined})
      const {access_token, token_expire_time} = res.session_handle

      setToken({
        token: access_token ?? '',
        token_expire_time,
      })

      return res
    },
    ...NO_REFETCH_OPTIONS,
  })
}

export default useGrubhubGetAuth
